var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2998_9994",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2998_9994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 42.5L30 33.5L39 42.5L42.5 39L33.5 30L42.5 21L39 17.5L30 26.5L21 17.5L17.5 21L26.5 30L17.5 39L21 42.5ZM30 55C26.5417 55 23.2917 54.3438 20.25 53.0312C17.2083 51.7188 14.5625 49.9375 12.3125 47.6875C10.0625 45.4375 8.28125 42.7917 6.96875 39.75C5.65625 36.7083 5 33.4583 5 30C5 26.5417 5.65625 23.2917 6.96875 20.25C8.28125 17.2083 10.0625 14.5625 12.3125 12.3125C14.5625 10.0625 17.2083 8.28125 20.25 6.96875C23.2917 5.65625 26.5417 5 30 5C33.4583 5 36.7083 5.65625 39.75 6.96875C42.7917 8.28125 45.4375 10.0625 47.6875 12.3125C49.9375 14.5625 51.7188 17.2083 53.0312 20.25C54.3438 23.2917 55 26.5417 55 30C55 33.4583 54.3438 36.7083 53.0312 39.75C51.7188 42.7917 49.9375 45.4375 47.6875 47.6875C45.4375 49.9375 42.7917 51.7188 39.75 53.0312C36.7083 54.3438 33.4583 55 30 55ZM30 50C35.5833 50 40.3125 48.0625 44.1875 44.1875C48.0625 40.3125 50 35.5833 50 30C50 24.4167 48.0625 19.6875 44.1875 15.8125C40.3125 11.9375 35.5833 10 30 10C24.4167 10 19.6875 11.9375 15.8125 15.8125C11.9375 19.6875 10 24.4167 10 30C10 35.5833 11.9375 40.3125 15.8125 44.1875C19.6875 48.0625 24.4167 50 30 50Z",
    fill: "#E60000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.b261ebd27d70b8c322525026894eb72a.svg";
export { ForwardRef as ReactComponent };